import * as Yup from "yup"
import {AssetType, ContractType, PositionType, SwitchEnum, SwitchUtils} from "../../../../models";
import {CreateResearchRequest, EditResearchRequest} from "../../../../models/priorities";


export class UpdateResearchForm {
    name: string | null = ""
    brandId: string = ""
    region?: string | null = ""
    city?: string | null = ""
    street?: string | null = ""
    priorityLevel: "URGENTE" | "ALTA" | "NORMALE" | "BASSA" = "NORMALE"
    preferredContractTypes?: string[] = []
    positionType?: PositionType | string | null = ""
    maxPrice?: number | string | null = ""
    airConditioning?: SwitchEnum = SwitchEnum.UNINTERESTING
    shopWindows?: SwitchEnum = SwitchEnum.UNINTERESTING
    parkingSlots?: SwitchEnum = SwitchEnum.UNINTERESTING
    singleLevel?: SwitchEnum = SwitchEnum.UNINTERESTING
    minDim?: number | string | null = ""
    maxDim?: number | string | null = ""
    propertyType?: AssetType | null = null


    public static fromServerResponse(response: any): UpdateResearchForm {
        const form = new UpdateResearchForm()

        if(response){
            form.name = response.name
            form.region = response.region
            form.city = response.city
            form.street = response.zone
            form.priorityLevel = response.priority
            form.brandId = response.brand.id

            if(response.requisiteOverrides){
                form.positionType = response.requisiteOverrides.positionType
                form.preferredContractTypes = Object.entries(response.requisiteOverrides.preferredContractTypes)
                    .filter(([_, v]) => v === true)
                    .map(([k, _]) => k)
                form.shopWindows = SwitchUtils.setSelectValue(response.requisiteOverrides.shopWindows)
                form.singleLevel = SwitchUtils.setSelectValue(response.requisiteOverrides.singleLevel)
                form.airConditioning = SwitchUtils.setSelectValue(response.requisiteOverrides.airConditioning)
                form.parkingSlots = SwitchUtils.setSelectValue(response.requisiteOverrides.parkingSlots)
                form.minDim = response.requisiteOverrides.minGla ?? response.requisiteOverrides.minLandArea
                form.maxDim = response.requisiteOverrides.maxGla ?? response.requisiteOverrides.maxLandArea
                form.maxPrice = response.requisiteOverrides.maxPrice
                form.propertyType = response.requisiteOverrides.preferredAssetType ?? null
            }
        }
        return form
    }

    public static getCreateRequest(values: any): CreateResearchRequest | null {
        let request: CreateResearchRequest | null = null

        const enumValues = Object.values(ContractType)
        const contracts: Record<string, boolean> = {}

        enumValues.forEach((enumValue) => {
            if(!values.preferredContractTypes) {
                return
            }

            contracts[enumValue] = values.preferredContractTypes?.includes(enumValue)
        })

        if(values){
            request = {
                name: values.name,
                brandId: values.brandId,
                region: values.region !== undefined  && values.region !== "" ? values.region : null,
                city: values.city !== undefined && values.city !== ""? values.city : null,
                street: values.street !== undefined && values.street !== "" ? values.street : null,
                priorityLevel: values.priorityLevel !== undefined ? values.priorityLevel : "NORMALE",
                preferredContractTypes: contracts,
                positionType: values.positionType !== undefined ? values.positionType : null,
                airConditioning: values.airConditioning !== undefined ? SwitchUtils.setSwitchValue(values.airConditioning) : null,
                shopWindows: values.shopWindows !== undefined ? SwitchUtils.setSwitchValue(values.shopWindows) : null,
                parkingSlots: values.parkingSlots !== undefined ? SwitchUtils.setSwitchValue(values.parkingSlots) : null,
                singleLevel: values.singleLevel !== undefined ? SwitchUtils.setSwitchValue(values.singleLevel) : null,
                minDim: values.minDim !== undefined ? values.minDim : null,
                maxDim: values.maxDim !== undefined ? values.maxDim : null,
                maxPrice: values.maxPrice !== undefined ? values.maxPrice : null,
                propertyType: values.propertyType
            }
        }
        return request
    }

    public static getUpdateRequest(values: any, priorityId: string): EditResearchRequest | null {
        let request: EditResearchRequest | null = null

        const enumValues = Object.values(ContractType)
        const contracts: Record<string, boolean> = {}

        enumValues.forEach((enumValue) => {
            if(!values.preferredContractTypes) {
                return
            }

            contracts[enumValue] = values.preferredContractTypes?.includes(enumValue)
        })

        if(values){
            request = {
                id: priorityId,
                name: values.name,
                brandId: values.brandId,
                region: values.region !== undefined  && values.region !== "" ? values.region : null,
                city: values.city !== undefined && values.city !== ""? values.city : null,
                street: values.street !== undefined && values.street !== "" ? values.street : null,
                priorityLevel: values.priorityLevel !== undefined ? values.priorityLevel : "NORMALE",
                preferredContractTypes: contracts,
                positionType: values.positionType !== undefined ? values.positionType : null,
                airConditioning: values.airConditioning !== undefined ? SwitchUtils.setSwitchValue(values.airConditioning) : null,
                shopWindows: values.shopWindows !== undefined ? SwitchUtils.setSwitchValue(values.shopWindows) : null,
                parkingSlots: values.parkingSlots !== undefined ? SwitchUtils.setSwitchValue(values.parkingSlots) : null,
                singleLevel: values.singleLevel !== undefined ? SwitchUtils.setSwitchValue(values.singleLevel) : null,
                minDim: values.minDim !== undefined ? values.minDim : null,
                maxDim: values.maxDim !== undefined ? values.maxDim : null,
                maxPrice: values.maxPrice !== undefined ? values.maxPrice : null,
                propertyType: values.propertyType
            }
        }
        return request
    }
}


const EditResearchValidation = {
    name: Yup.string().required("Il campo è obbligatorio"),
    brandId: Yup.string().required("Il campo è obbligatorio"),
}

export default Yup.object()
    .shape(
        EditResearchValidation,
    )
    .required()
